/**
 * Created by mehmetyurtar on 31/08/2017.
 */
import React from 'react';
import {browserHistory} from 'react-router'

const DesignerToolbar = props => {
    return (
        <div style={{width:"100%", background:"#fbfbfb", paddingLeft:"10px", overflow: "hidden", padding: "8px 0 4px 10px",lineHeight:"30px"}}>
                    <div className="designer--page__toolbar--item__container" style={{width: "20%",borderLeft: 0, paddingLeft: 0}}>
                        <span>Şablon ismi: </span>
                        <input style={{width: "65%","border":"2px solid #ccc","borderRadius":"4px"}} type="text" key="templateName" value={props.templateName} onChange={props.onTemplateNameChange}/>
                    </div>
            <div className="designer--page__toolbar" style={{display:'inline-block', float:"right", width:"80%"}}>
                <ul style={{listStyle: "none", padding:0, margin:0}}>
                    <li className="designer--page__toolbar--item__container">
                        <span style={{marginRight: "5px"}}>Kağıt Boyutu: </span>
                        <span className="designer--page--size__container">
                          <span
                              className={props.paperWidth ===  400 && props.paperHeight === 240 ? "designer--page--size designer--page--size__selected" : "designer--page--size"}
                              onClick={props.predefinedPaperSize.bind(null, 400, 240)}>
                              5cm x 3cm
                          </span>
                        </span>
                        <span className="designer--page--size__container">
                          <span
                              className={props.paperWidth ===  479 && props.paperHeight === 319 ? "designer--page--size designer--page--size__selected" : "designer--page--size"}
                              onClick={props.predefinedPaperSize.bind(null, 479, 319)}>
                              6cm x 4cm
                          </span>
                        </span>
                        <span className="designer--page--size__container">
                          <span
                              className={props.paperWidth ===  560 && props.paperHeight === 240 ? "designer--page--size designer--page--size__selected" : "designer--page--size"}
                              onClick={props.predefinedPaperSize.bind(null, 560, 240)}>
                              7cm x 3cm
                          </span>
                        </span>
                        <span className="designer--page--size__container" style={{"display":"none"}}>
                          <span className="designer--page--size__spec">
                              <input disabled={true} type="text" name="paperWidth" value={props.paperWidth} onChange={props.onCustomPaperSizeChange}/>
                              px
                          </span>
                          <span style={{marginLeft: "10px"}}>x</span>
                          <span className="designer--page--size__spec">
                              <input disabled={true} type="text" name="paperHeight" value={props.paperHeight} onChange={props.onCustomPaperSizeChange}/>
                              px
                          </span>
                      </span>
                        <span className="designer--page--size__container">
                          <span className="designer--page--size__spec">
                              <input disabled={false} type="text" name="paperWidthCm" value={props.paperWidthCm} onChange={props.onCustomPaperSizeChange}/>
                              cm
                          </span>
                          <span style={{marginLeft: "10px"}}>x</span>
                          <span className="designer--page--size__spec">
                              <input disabled={false} type="text" name="paperHeightCm" value={props.paperHeightCm} onChange={props.onCustomPaperSizeChange}/>
                              cm
                          </span>
                      </span>
                    </li>

                    <li className="designer--page__toolbar--item__container">
                        <button className="btn btn-primary" onClick={props.save}>Kaydet</button>
                    </li>
                    <li className="designer--page__toolbar--item__container">
                        <button onClick={() => { browserHistory.push('/dashboard/barcodeTemplates')}} className="btn btn-danger">İptal</button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default DesignerToolbar;